import padelTournamentImage from "@/assets/padel-tournament.png";

export const TournamentImage = () => {
  return (
    <img
      src={padelTournamentImage}
      alt="Padel Tournament"
      className="w-full h-48 md:h-[236px] object-cover rounded-lg mb-6"
    />
  );
};
